import RefreshMsgsButton from './RefreshMsgsButton';

export default RefreshMsgsButton;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/RefreshMsgsButton/index.js